function previousNextService (sessionStorageService) {
    const SRP_NP_LISTINGS = 'srp-np-listings';
    const SRP_NP_PAGINATION = 'srp-np-pagination';
    const SRP_NP_COUNT = 'srp-np-count';

    return {
        getVisibility,
        getCurrentListingSpot,
        getPreviousConfig,
        getNextConfig,
        getLastListingSpot
    };

    function getVisibility () {
        return getListingIds().length > 1;
    }

    function getCurrentListingSpot (listingId) {
        const pageInfo = JSON.parse(sessionStorageService.getItem(SRP_NP_PAGINATION));
        const listingsBeforeCurrentPage = pageInfo.page === 1
            ? 0
            : pageInfo.page * pageInfo.perPage;

        const listingIds = getListingIds();
        const placeOnCurrentPage = listingIds.indexOf(listingId) + 1;

        return listingsBeforeCurrentPage + placeOnCurrentPage;
    }

    function getLastListingSpot () {
        return JSON.parse(sessionStorageService.getItem('srp-np-listings'))[0].listingIds.length;
    }

    function getPreviousConfig (listingId) {
        const listingIds =  getListingIds();
        const currentListingIndex = listingIds.indexOf(listingId);

        return {
            text: 'Prev',
            href: `/vehicledetail/detail/${listingIds[currentListingIndex - 1]}/overview/`
        };
    }

    function getNextConfig (listingId) {
        const listingIds =  getListingIds();
        const currentListingIndex = listingIds.indexOf(listingId);

        return {
            text: 'Next',
            href: `/vehicledetail/detail/${listingIds[currentListingIndex + 1]}/overview/`
        };
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////

    function getListingIds () {
        const pagesOfListings = JSON.parse(sessionStorageService.getItem(SRP_NP_LISTINGS)) || [];

        return (pagesOfListings[0] && pagesOfListings[0].listingIds) || [];
    }
}

previousNextService.$inject = [
    'sessionStorageService'
];

export default previousNextService;
